<template>
  <div class="tx-list-page">
    <v-container fluid grid-list-xl>
      <v-flex xs12>
        <div class="list-hero">
          <p class="list-crumb">Transit / Entregas</p>
          <h1 class="list-title">Entregas</h1>
          <p class="list-subtitle">
            Marca las facturas entregadas y adjunta el comprobante de recibido.
          </p>
        </div>
      </v-flex>

      <search v-on:download="onDownload" v-on:searching="onSearch"></search>

      <v-layout row wrap>
        <v-flex xs12>
          <v-card class="tx-card">
            <div class="tx-toolbar">
              <div class="tx-toolbar__info">
                <span class="tx-chip">
                  <v-icon small class="tx-chip__icon">local_shipping</v-icon>
                  {{ meta.totalGroups }} trámites
                  <template v-if="meta.totalInvoices !== meta.totalGroups">
                    ({{ meta.totalInvoices }} facturas)
                  </template>
                </span>
              </div>
            </div>
            <v-divider></v-divider>

            <v-card-text class="pa-0">
              <div class="table-wrap">
                <table class="tx-table">
                  <thead>
                    <tr>
                      <th># Factura</th>
                      <th>Entregada</th>
                      <th class="th-center">Detalles</th>
                      <th class="th-center">Recibido</th>
                    </tr>
                  </thead>
                  <!-- Un <tbody> por trámite, como en Contabilidad: la banda
                       con el consecutivo y, debajo, una fila por factura. -->
                  <tbody
                    v-for="group in groups"
                    :key="group.key"
                    class="tx-group"
                  >
                    <!-- Banda del trámite (texto de TramiteBand): solo
                         texto. Cada factura se marca con su propio switch en
                         la columna Entregada, también las del consolidado; la
                         banda avisa cuando ya están todas. -->
                    <tr
                      class="tx-group-row"
                      :class="{ 'tx-group-row--single': !esConsolidado(group) }"
                    >
                      <td colspan="4">
                        <v-icon small class="tx-group-row__icon">
                          {{ esConsolidado(group) ? 'layers' : 'description' }}
                        </v-icon>
                        {{ etiquetaTramite(group) }}
                        <strong>{{ consecutivoDe(group) }}</strong>
                        &middot; {{ facturasDe(group) }}
                        <span
                          v-if="esConsolidado(group)"
                          class="tx-group-row__muted"
                        >
                          &middot; CIF total {{ money(cifTramiteDe(group)) }}
                        </span>
                        <span
                          v-if="controlFdDe(group)"
                          class="tx-group-row__muted"
                        >
                          &middot; Control F&amp;D: {{ controlFdDe(group) }}
                        </span>
                        <span
                          v-if="
                            esConsolidado(group) &&
                              pendingOf(group).length === 0
                          "
                          class="tx-group-row__muted"
                        >
                          &middot; todas entregadas
                        </span>
                      </td>
                    </tr>

                    <tr
                      v-for="item in group.invoices"
                      :key="item.id"
                      :class="{ 'tx-child-row': esConsolidado(group) }"
                    >
                      <td class="tx-cell--strong">
                        {{ item.invoiceNumber || '—' }}
                      </td>
                      <td>
                        <v-switch
                          :key="item.id"
                          :readonly="item.delivered === 'YES'"
                          :input-value="item.delivered === 'YES'"
                          color="#254f87"
                          class="tx-switch"
                          hide-details
                          inset
                          @change="saveDelivered(item)"
                        ></v-switch>
                      </td>
                      <td class="th-center">
                        <v-btn
                          class="btn-detail"
                          icon
                          small
                          title="Ver detalles"
                          @click="handleDetails(item)"
                        >
                          <v-icon small>visibility</v-icon>
                        </v-btn>
                      </td>
                      <td class="th-center">
                        <v-btn
                          v-if="!item.photoDelivered"
                          class="btn-attach"
                          icon
                          small
                          title="Adjuntar comprobante"
                          @click="handleAttachment(item, group)"
                        >
                          <v-icon small>attach_file</v-icon>
                        </v-btn>
                        <v-btn
                          v-else
                          class="btn-receipt"
                          icon
                          small
                          title="Ver comprobante"
                          @click="handleAttachment(item, group)"
                        >
                          <v-icon small>receipt_long</v-icon>
                        </v-btn>
                      </td>
                    </tr>
                  </tbody>

                  <tbody v-if="!pagination.loading && groups.length === 0">
                    <tr>
                      <td colspan="4" class="empty-state">
                        No se encontraron facturas con los filtros aplicados.
                      </td>
                    </tr>
                  </tbody>
                  <tbody v-if="pagination.loading">
                    <tr>
                      <td colspan="4" class="empty-state">Cargando...</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </v-card-text>
          </v-card>
        </v-flex>

        <v-flex xs12 v-if="pagination.pages">
          <div class="list-footer">
            <div class="list-footer__count">
              Mostrando {{ groups.length }} de {{ meta.totalGroups }} trámites
              ({{ meta.totalInvoices }}
              facturas)
            </div>
            <v-pagination
              v-model="pagination.page"
              :length="pagination.pages"
              :total-visible="7"
              color="#254f87"
              @input="asyncPagination"
            ></v-pagination>
          </div>
        </v-flex>
      </v-layout>
    </v-container>

    <v-dialog max-width="500" v-if="dialog.message" v-model="dialog.show">
      <message
        :key="dialog.key"
        :options="dialog"
        v-on:close="dialog.show = false"
      ></message>
    </v-dialog>

    <v-dialog max-width="1024" v-if="detail.data" v-model="detail.show">
      <compose
        :item="detail.data"
        v-on:close-detail="detail.show = false"
      ></compose>
    </v-dialog>

    <v-dialog max-width="560" v-if="attachment.data" v-model="attachment.show">
      <attachment
        :item="attachment.data"
        :key="attachment.key"
        v-on:close-attach="attachment.show = false"
        v-on:save-attach="saveAttachment"
      ></attachment>
    </v-dialog>

    <v-dialog max-width="350" persistent v-model="loading">
      <loading></loading>
    </v-dialog>

    <v-snackbar v-model="snack.show" :timeout="3000" :color="snack.color">
      {{ snack.message }}
      <v-btn flat @click="snack.show = false">Cerrar</v-btn>
    </v-snackbar>
  </div>
</template>

<script>
import compose from './../dialog/DialogDetails'
import loading from './../dialog/DialogLoading'
import attachment from './../dialog/DialogAttachment'
import message from './../dialog/Message'
import search from './Search.vue'
import SessionHelper from '@/helpers/SessionHelper'
import TramiteBand from './mixins/TramiteBand'

export default {
  // La banda del trámite se lee igual que en Contabilidad y el resto de
  // Transit (consecutivo CONS-/IND-, facturas, CIF y control F&D).
  mixins: [TramiteBand],
  components: {
    compose,
    loading,
    attachment,
    message,
    search,
  },
  data() {
    return {
      loading: true,
      // El backend agrupa por consolidado, igual que las demas pantallas de
      // Transit. Antes esta vista usaba v-data-table, que no admite filas de
      // encabezado entre los registros.
      groups: [],
      meta: { totalGroups: 0, totalInvoices: 0 },
      pagination: {
        page: 1,
        rpp: this.$config.resultsPerPage,
        totalItems: 0,
        loading: true,
        pages: 0,
        search: {},
      },
      snack: {
        show: false,
        color: 'info',
        message: '',
      },
      detail: {
        show: null,
        data: null,
      },
      dialog: {
        show: null,
        key: 0,
      },
      attachment: {
        show: null,
        data: null,
        key: 0,
      },
    }
  },

  created() {
    this.asyncPagination()
  },
  methods: {
    // Facturas del grupo que aun no se han entregado.
    pendingOf(group) {
      return group.invoices.filter(i => i.delivered !== 'YES')
    },
    helperPaginate(response) {
      this.groups = (response && response.groups) || []
      this.meta = {
        totalGroups: (response && response.totalGroups) || 0,
        totalInvoices: (response && response.totalInvoices) || 0,
      }
      // Se pagina por GRUPO: un consolidado no queda partido entre paginas.
      this.pagination.totalItems = this.meta.totalInvoices
      this.pagination.pages =
        Math.ceil(this.meta.totalGroups / this.pagination.rpp) || 0
      this.loading = false
      this.pagination.loading = false
    },
    asyncPagination() {
      this.pagination.loading = true

      const filter = {
        rpp: this.pagination.rpp,
        page: this.pagination.page,
        status: 'deliver',
        ...this.pagination.search,
      }

      return new Promise(resolve => {
        this.$store
          .dispatch('invoices/getConsolidated', filter)
          .then(response => {
            this.helperPaginate(response)
            return resolve()
          })
      })
    },
    handleDetails(row) {
      this.loading = true
      this.$store
        .dispatch('invoices/getItems', { invoiceId: row.id })
        .then(items => {
          this.loading = false
          this.detail = {
            // El listado agrupado trae laboratorio/distribuidor como texto,
            // pero DialogDetails espera lab_invoices/dist_invoices.
            data: {
              ...row,
              lab_invoices: { id: row.labId, name: row.laboratorio },
              dist_invoices: { id: row.distId, name: row.distribuidor },
              products: items ? items : null,
            },
            show: true,
          }
        })
    },
    // El comprobante de entrega de un consolidado es uno solo para todo el
    // grupo, igual que su aprobacion y su pago; en un tramite individual
    // aplica a esa factura. El dialogo tambien muestra el expediente completo.
    handleAttachment(row, group) {
      const isGroup = group && group.consolidated
      this.attachment = {
        data: {
          invoices: isGroup ? group.invoices.map(i => i.id) : [row.id],
          invoiceNumber: isGroup ? null : row.invoiceNumber,
          code: isGroup ? this.consecutivoDe(group) : null,
        },
        show: true,
        key: this.attachment.key + 1,
      }
    },
    // Entrega, por factura o por consolidado completo. El backend ya acepta el
    // arreglo de facturas.
    runDelivered(ids, message) {
      if (!ids || !ids.length) return Promise.resolve()
      return this.$store
        .dispatch('transit/delivered', { invoices: ids.slice() })
        .then(() => this.asyncPagination())
        .then(() => {
          this.snack = { show: true, color: 'success', message }
        })
        .catch(() => {
          this.snack = {
            show: true,
            color: 'error',
            message: 'No se pudo registrar la entrega.',
          }
        })
    },
    saveDelivered(row) {
      if (row.delivered === 'YES') return
      this.runDelivered(
        [row.id],
        `La factura ${row.invoiceNumber} fue marcada como entregada.`
      )
    },
    saveAttachment() {
      this.attachment.show = false
      this.loading = true
      this.asyncPagination().then(() => {
        this.dialog = {
          message: 'Adjunto agregado',
          show: true,
          key: this.dialog.key + 1,
        }
      })
    },
    onSearch(params) {
      Object.keys(params).forEach(function(key) {
        if (params[key] == null || params[key] === '') delete params[key]
      })

      this.pagination.search = params
      this.pagination.page = 1
      this.asyncPagination()
    },
    onDownload() {
      const filter = {
        status: 'deliver',
        ...this.pagination.search,
        token: SessionHelper.token,
      }
      this.$socket.emit('exportTransitInvoices', filter)
    },
  },
}
</script>

<style scoped src="./transit-list.css"></style>

<style scoped>
/* El switch dentro de la tabla no debe empujar la fila. */
.tx-switch {
  margin: 0 !important;
  padding: 0 !important;
}
</style>
